/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Info block colors constants
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { _137C, Fury, Green } from './palette';

export const infoBlockBorderColorError = Fury;
export const infoBlockBorderColorSuccess = Green;
export const infoBlockBorderColorWarning = _137C;
